import React from "react";
import ToolTip from "../../../../parts/tooltip-portal";
import { S3 } from "../../../../constants";
import SvgIcon from "../../../../parts/SvgIcon";

class ImageSelectorSmall extends React.Component {
  constructor(props) {
    super(props);
    this.fileInput = null;
    this.setFileInputRef = (element) => {
      this.fileInput = element;
    };
    this.state = {
      backgroundImage: null,
      imageValue: null,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleBackgroundImage = this.handleBackgroundImage.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.updateBackground = this.updateBackground.bind(this);
  }

  updateBackground(imageObject = null) {
    const value = imageObject ? imageObject : this.props.value;
    if (!value) return;
    if (!value.s3Path) return;

    const backgroundImage = `${S3.PATH}${value.s3Path}`;

    this.setState({
      backgroundImage,
      imageValue: value,
    });
  }

  componentDidMount() {
    this.updateBackground();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.updateBackground(nextProps.value);
    }
  }

  handleClick() {
    if (this.fileInput) this.fileInput.click();
  }

  handleBackgroundImage(backgroundImage) {
    this.setState({ backgroundImage });
  }

  handleInput({ target }) {
    const { onChange = () => {} } = this.props;

    const reader = new FileReader();

    reader.addEventListener("load", () => {
      const uploaded_image = reader.result;
      const backgroundImage = uploaded_image;
      this.handleBackgroundImage(backgroundImage);
      onChange({ target, backgroundImage });
    });

    if (target && target.files && target.files[0] instanceof Blob) {
      reader.readAsDataURL(target.files[0]);
    }
  }

  render() {
    const {
      id = "",

      imageInputs = [],
      inputName = "",

      classNames = "",
      allowedExtensions = "image/*",
    } = this.props;

    const { backgroundImage, imageValue } = this.state;

    return (
      <label
        className={`image-selector-sm mobile-hidden ${classNames} ${
          !backgroundImage ? "no-image" : ""
        }`}
        htmlFor={`upload-${id}`}
      >
        {imageInputs.map((inputProps, idx) => {
          return (
            <input
              key={idx}
              type="hidden"
              name={inputProps.name}
              value={inputProps.value}
            />
          );
        })}
        <input
          ref={this.setFileInputRef}
          type="file"
          accept={allowedExtensions}
          name={inputName}
          id={`upload-${id}`}
          hidden
          onChange={this.handleInput}
          defaultValue={imageValue}
        />

        {!backgroundImage ? (
          <>
            <SvgIcon src="/img/new-icons/upload-file.svg" />
            <span>Choose file</span>
          </>
        ) : (
          <>
            <img alt="in app logo" src={backgroundImage} />
            <span>Change</span>
          </>
        )}
      </label>
    );
  }
}

export default ImageSelectorSmall;
